<template id="contentArea">
<section class="contentArea" v-if="content != null">
  <div class="container">
    <div :class="rowalign?'row '+rowalign:'row'">
      <div v-if="content.id" :saveid="content.id" class="col-md-12 col-sm-12" v-html="content.value" @blur="saveData($event)" @click="edit($event)"></div>
      <div v-else class="col-md-12 col-sm-12" v-html="content"></div>
    </div>
  </div>
</section>
</template>

<script>

import utils from './Utils.vue'

export default {
  name: 'contentArea',
  props:['name', 'sname', 'content', 'rowalign'],
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
    edit:function(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.altKey) {
          if (this.content.editable) {
            console.log('edit source');
          } else {
            this.content.editable = true;
          }
          this.$forceUpdate();
        }
      }
    },
    saveData:function(evt) {
      this.content.editable = false;
      var c = $(evt.target).html();
      if (this.content.id) {
        utils.saveData({
            mode: 'update',
            repos: 'json',
            value: c,
            name: $(evt.target).attr('saveid') 
          }, function() {
          this.content.value = c;
          console.log('saved');
        });
      } else {
        this.content = c;
      }
      this.$forceUpdate();
    }
  },
  mounted: function() {
    var self = this;
    utils.EventBus.$on('global-click', function() {
      //self.content.editable = false;
      self.$forceUpdate();
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContentArea.vue